import constants from '@/constants';
import { getToken } from '@/scripts/token.js';
import store from '@/store/index.js';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getSmartFilterAxios(assetTypeID = null) {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    const assetTypes = await calculateAssetType(assetTypeID);

    let paramsList = [];
    for (let index = 0; index < assetTypes.length; index++) {
        paramsList.push({
            method: METHOD.GET,
            url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.SMART_FILTER_GET}`,
            params: {
                asset_type_id: assetTypes[index],
            },
            headers: {
                Authorization: token,
                'Cache-Control': 'no-cache',
            },
        });
    }

    return paramsList;
}

export async function getSmartFilter(assetTypeID = null) {
    const assetTypes = await calculateAssetType(assetTypeID);
    const paramsList = [];

    for (let index = 0; index < assetTypes.length; index++) {
        const response = await axiosRequest({
            url: constants.URL.SMART_FILTER_GET,
            method: METHOD.GET,
            requestName: 'GET SMART FILTER',
            isLoader: false,
            params: {
                asset_type_id: assetTypes[index],
            },
        });
        paramsList.push(response == null ? [] : response);
    }

    return paramsList;
}

async function calculateAssetType(assetTypeID) {
    const assetTypes = [];
    if (assetTypeID == null) {
        const allAssetTypes = await store.getters.ASSET_TYPES;
        allAssetTypes.forEach((assetTypeValue, assetTypeIndex) => {
            assetTypes.push(assetTypeValue.id);
        });
    } else {
        assetTypes.push(assetTypeID);
    }

    return assetTypes;
}

export async function createSmartFilter(data) {
    const response = await axiosRequest({
        url: constants.URL.SMART_FILTER_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE SMART FILTER',
        data: data,
    });

    return response;
}

export async function updateSmartFilter(data) {
    const response = await axiosRequest({
        url: constants.URL.SMART_FILTER_UPDATE,
        method: METHOD.PUT,
        requestName: 'UPDATE SMART FILTER',
        data: data,
    });

    return response == null ? false : true;
}

export async function deleteSmartFilter(id) {
    const response = await axiosRequest({
        url: constants.URL.SMART_FILTER_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE SMART FILTER',
        params: {
            smart_filter_id: id,
        },
    });

    return response == null ? false : true;
}
